<template>
  <BaseModal v-bind="modalChangePassword">
    <template v-slot:header>
      <h4>Definição de senha</h4>
    </template>

    <template v-slot:default>
      <InfoCard v-bind="infoCard">
        <p>
          O cadastro da senha é útil para acessar o Sispessoal sem o uso da
          Intranet, através do
          <BaseRouterLink v-bind:to="{ name: 'containerLogin' }"
            >endereço de login</BaseRouterLink
          >. A nova senha tem que ter pelo menos 6 dígitos.
        </p>
      </InfoCard>

      <div class="row">
        <BaseTextInput v-bind="passwordField" v-model="password" />
      </div>
    </template>

    <template v-slot:footer>
      <BaseButton
        class="modal-close"
        v-bind:disabled="disabled"
        material-type="flat"
        >Cancelar</BaseButton
      >
      <BaseButton
        material-type="flat"
        v-bind:disabled="disabled"
        v-on:click="save"
        >Salvar</BaseButton
      >
    </template>
  </BaseModal>
</template>

<script>
import { API_URL } from "../../constants";

export default {
  name: "ChangePasswordModal",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    value: Object
  },
  data() {
    return {
      disabled: false,
      infoCard: {
        id: `${this.id}-infocard`,
        title: "Senha no SisPessoal"
      },
      password: null,
      passwordField: {
        id: `${this.id}-password`,
        type: "password",
        label: "Nova senha",
        placeholder: "Digite a nova senha",
        validate: true
      },
      modalChangePassword: {
        id: this.id,
        hasFixedFooter: true,
        modalOptions: {
          onOpenStart: this.onModalOpen,
          dismissible: false
        }
      }
    };
  },
  methods: {
    isValid() {
      return this.password && this.password.length >= 6;
    },
    onModalOpen() {
      // Reseta algumas variáveis
      this.disabled = false;
      this.password = null;
    },
    async save() {
      if (!window.M) {
        return;
      }

      if (!this.isValid()) {
        return this.$notification.pushError(
          "A nova senha tem que ter pelo menos 6 dígitos"
        );
      }

      if (!this.value.self && !this.value.userId) {
        return this.$notification.pushError(
          "Um usuário precisa ser selecionado"
        );
      }

      let url = `${API_URL}/acesso/usuario/senha`;

      if (this.value.userId) {
        url = `${API_URL}/acesso/usuario/${this.value.userId}/senha`;
      }

      const body = { senha: this.password };

      try {
        this.disable = true;
        await this.$http.put(url, body);
        this.$notification.pushSuccess("Senha cadastrada com sucesso");
        this.$utils.Components.closeModal(this.id);
      } catch (error) {
        this.$notification.pushError(error.message);
      } finally {
        this.disable = false;
      }
    }
  }
};
</script>
